module.exports = __webpack_public_path__ + "static/media/BRICOI.5de298a7.svg";